import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-prepayment',
  templateUrl: './prepayment.component.html',
  styleUrls: ['./prepayment.component.css']
})
export class PrepaymentComponent implements OnInit {
    argType;

    argValue;

    prepaymentKeyno;

    public invoiceButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'invoicehead', gotoParms: () => this.edit!.invoice_no ?? '' }];

    public edit?: Edit;

    public selectListCashTypePayments: CashTypePaymentItem[] = [];

    public selectListPaymentPlans: Item[] = [];

    public creating = false;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.prepaymentKeyno = this.stateService.getStateParams()['prepayment_keyno'];
    }

    private async loadEdit() {
        if (!!this.argType && !!this.argValue && !!this.prepaymentKeyno) {
            this.edit = (await this.datatask.Post(465, {
                argtype: this.argType,
                argvalue: this.argValue,
                prepayment_keyno: this.prepaymentKeyno
            }))[0];
        }
    }

    private async loadCashTypePayments() {
        this.selectListCashTypePayments = await this.datatask.Post(466);
    }

    private async loadPaymentPlans() {
        if (!this.edit) return;

        return this.selectListPaymentPlans = await this.datatask.Post(2746, this.edit);
    }

    public async createChanges() {
        if (!!this.edit) {
            try {
                this.creating = true;

                const response = (await this.datatask.Post(2638, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.loadEdit();
                }
            } finally {
                this.creating = false;
            }
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;
                this.edit.argtype = this.argType;
                this.edit.argvalue = this.argValue;

                await this.datatask.Post(467, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(469, { prepayment_keyno: this.edit.prepayment_keyno });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadCashTypePayments();
        this.loadPaymentPlans();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    prepayment_keyno: string;
    order_internal_no: string;
    amount: string;
    date: string;
    regby_username: string;
    description: string;
    reg_datetime: string;
    cashtype_keyno: string;
    enable_edit: string;
    amount_total_topay: string;
    amount_paid_before: string;
    amount_topay_rest: string;
    payment_method: string;
    show_setting: string;
    show_delete: string;
    invoice_no: string;
    isnew: string;
    show_create_akonto_invoice: string;
    project_keyno: string;
    paymentplan_keyno: string;
    nbr_of_paymentplans: string;
    argtype: string;
    argvalue: string;
}

interface CashTypePaymentItem {
    cashtype_keyno: string;
    cashtype_name: string;
    orderby: number;
}
